interface IconTicketProps {
  width?: number;
  height?: number;
  color?: string;
}

export const IconTicketSvg: React.FC<IconTicketProps> = ({
  width = 20,
  height = 40,
  color = 'white'
}) => {
  return (<svg
    version="1.1"
    width={width}
    height={height}
    x="0px"
    y="0px"
    viewBox="0 0 58 40"
  >
    <g>
      <g>
        <path style={{ fill: color, stroke: color, strokeWidth: "2" }} d="M56.3,19.9c0.5,0,0.8-0.4,0.8-0.8V8.8c0-0.5-0.4-0.8-0.8-0.8h-2.3l-1-6.7c0-0.5-0.5-0.8-0.9-0.7L39.4,2.4h0
                L1.9,8c0,0-0.7,0.1-0.7,0.8v10.2c0,0.5,0.4,0.8,0.8,0.8c2.1,0,3.7,1.7,3.7,3.7S4.1,27.4,2,27.4c-0.5,0-0.8,0.4-0.8,0.8v10.2
                c0,0.5,0.4,0.8,0.8,0.8h54.2c0.5,0,0.8-0.4,0.8-0.8V28.2c0-0.5-0.4-0.8-0.8-0.8c-2.1,0-3.7-1.7-3.7-3.7S54.3,19.9,56.3,19.9
                L56.3,19.9z M38.7,4.2l0.3,2.2c0,0.4,0.4,0.7,0.8,0.7H40c0.5,0,0.8-0.5,0.7-0.9L40.4,4l11.2-1.7L52.4,8H13.2L38.7,4.2z M55.5,29
                v8.7H43.3v-2.3c0-0.5-0.4-0.8-0.8-0.8s-0.8,0.4-0.8,0.8v2.3H2.9V29c2.9-0.5,5-3.2,4.5-6.1c-0.4-2.3-2.2-4.2-4.5-4.5V9.7h38.7v2.2
                c0,0.5,0.4,0.8,0.8,0.8s0.8-0.4,0.8-0.8V9.6h12.2v8.7c-2.9,0.5-5,3.2-4.5,6.1C51.4,26.8,53.2,28.6,55.5,29z"></path>
        <path style={{ fill: color, stroke: color, strokeWidth: "2" }} d="M42.5,24.9c-0.5,0-0.8,0.4-0.8,0.8v5.5c0,0.5,0.4,0.8,0.8,0.8s0.8-0.4,0.8-0.8v-5.4
                C43.3,25.3,42.9,24.9,42.5,24.9L42.5,24.9z"></path>
        <path style={{ fill: color, stroke: color, strokeWidth: "2" }} d="M42.5,15.3c-0.5,0-0.8,0.4-0.8,0.8v5.5c0,0.5,0.4,0.8,0.8,0.8s0.8-0.4,0.8-0.8v-5.5
                C43.3,15.7,42.9,15.3,42.5,15.3z"></path>
        <path style={{ fill: color, stroke: color, strokeWidth: "2" }} d="M11.9,16.6h10.2c0.5,0,0.8-0.4,0.8-0.8c0-0.5-0.4-0.8-0.8-0.8H11.9c-0.5,0-0.8,0.4-0.8,0.8
                C11.1,16.3,11.4,16.6,11.9,16.6z"></path>
        <path style={{ fill: color, stroke: color, strokeWidth: "2" }} d="M32.4,20.2H11.9c-0.5,0-0.8,0.4-0.8,0.8s0.4,0.8,0.8,0.8h20.5c0.5,0,0.8-0.4,0.8-0.8S32.8,20.2,32.4,20.2z"></path>
        <path style={{ fill: color, stroke: color, strokeWidth: "2" }} d="M32.4,25.4H11.9c-0.5,0-0.8,0.4-0.8,0.8s0.4,0.8,0.8,0.8h20.5c0.5,0,0.8-0.4,0.8-0.8S32.8,25.4,32.4,25.4z"></path>
        <path style={{ fill: color, stroke: color, strokeWidth: "2" }} d="M32.4,30.7H11.9c-0.5,0-0.8,0.4-0.8,0.8s0.4,0.8,0.8,0.8h20.5c0.5,0,0.8-0.4,0.8-0.8S32.8,30.7,32.4,30.7z"></path>
      </g>
    </g>
  </svg>);
};
